<template>
  <div :class="baseClass">
    <v-icon :dark="dark">mdi-calendar</v-icon>
    <div class="v-input__control">
      <div class="v-input__slot">
        <div class="v-text-field__slot">
          <masked-input
            v-model="value"
            mask="11.11.1111 11:11"
            :placeholder="placeholder"
            :disabled="disabled"
            :style="textStyle"
          />
        </div>
      </div>
      <label v-if="hasErrorText" class="date-error-label">{{ errorText }}</label>
    </div>
  </div>
  
</template>

<script>

import moment from 'moment';
import MaskedInput from 'vue-masked-input';

const DateTimeFormat = 'DD.MM.YYYY HH:mm';

export default {
  name: 'DateTime',
  components: {
    MaskedInput,
  },
  props: {
    initialValue: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    value(newValue) {
      if (!newValue) {
        this.$emit('changed', null);
      } else {
        const dateTime = moment(newValue, DateTimeFormat);
        if (dateTime.isValid()) {
          this.$emit('changed', dateTime.utc().format());
        } else {
          this.$emit('changed', null);
        }
      }
    }
  },
  computed: {
    hasErrorText() {
      return (this.errorMessages && this.errorMessages.length > 0) ;
    },
    errorText() {
      return this.errorMessages.join(',');
    },
    textStyle() {
      if (!this.error) {
        return null;
      }
      return 'color: #ff5252; carret-color: ff5252;';
    },
    baseClass() {
      const theme = this.dark ? 'theme--dark' : 'theme--light';
      return `v-input v-input--is-readonly ${theme} v-text-field v-text-field--is-booted`;
    }
  },
  mounted() {
  },
  methods: {
    clear() {
      this.value = '';
    },
    parseUtc(utc) {
      if (!utc) {
        return '';
      }

      const m = moment.utc(utc);
      if (!m.isValid()) {
        return '';
      }

      return m.local().format(DateTimeFormat);
    }
  },
  data() {
    return {
      value: this.parseUtc(this.initialValue),
    };
  },
};
</script>

<style>
  .custom-date-time {
    color: rgba(0, 0, 0, 0.87);
    max-height: 32px;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    line-height: 20px;
    padding: 8px 0 8px;
    max-width: 100%;
    min-width: 0px;
    width: 100%;
    background-color: transparent;
    border-style: none;
    font: inherit;
    border-radius: 0;
    border: none;
  }
  .date-error-label {
    color: #ff5252;
    font-size: 12px;
  }
</style>
